import { render, staticRenderFns } from "./campaignStatus.vue?vue&type=template&id=b776cad4&scoped=true&"
import script from "./campaignStatus.vue?vue&type=script&lang=js&"
export * from "./campaignStatus.vue?vue&type=script&lang=js&"
import style0 from "./campaignStatus.vue?vue&type=style&index=0&id=b776cad4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b776cad4",
  null
  
)

export default component.exports